import { createReducer } from '@reduxjs/toolkit';
import { RequestError, LatestCommunication } from 'types';
import { fetchLatestCommunication, fetchedLatestCommunication } from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchLatestCommunication, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedLatestCommunication, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.data = undefined;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
        state.data = payload as LatestCommunication;
      }
    })
);
